import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { PuzzleHelpDialogInjectableInterface } from '../../shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-quiz-help-screen',
  templateUrl: './quiz-help-screen.component.html',
  styleUrls: ['./quiz-help-screen.component.css'],
  standalone: true,
  imports: [CommonModule, IonText, TranslateModule],
})
export class QuizHelpScreenComponent implements PuzzleHelpDialogInjectableInterface {
  data: any;
  translationKey: string;

  constructor(private framework: PuzzleFrameworkService) {
    this.translationKey = this.framework.getTranslationKey();
  }

  setData(data: any): void {}
}
